<template>
  <el-table-column
    prop="routes"
    type="expand"
  >
    <template slot-scope="scope">
      <el-timeline class="route-timeline">
        <el-timeline-item
          v-for="route in scope.row.all_routes"
          :key="route.id"
          :hide-timestamp="true"
          :icon="getStatus(route.status).icon"
          :type="getStatus(route.status).type"
          size="large"
        >
          <el-card>
            <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
              <div>
                <strong>{{ route.shop && route.shop.name }}</strong> {{ `(${route.shop && route.shop.partner && route.shop.partner.company.name})` }}
              </div>
              <el-tag v-if="route.status === 'done'" type="success" size="small" style="">Kész</el-tag>
              <el-tag v-if="route.status === 'todo'" type="info" size="small" style="">Elintézendő</el-tag>
              <el-tag v-if="route.status === 'in-progress'" type="warning" size="small" style="">
                <i class="el-icon-more"></i>
                Folyamatban
              </el-tag>
              <el-tag v-if="route.status === 'failed'" type="danger" size="small" style="">Sikertelen</el-tag>
            </div>
            <div>
              <p>Üzlet címe: {{ route.shop.address && route.shop.address.full_address }}</p>
              <p>Adószám: {{ route.shop.partner && route.shop.partner.company && route.shop.partner.company.tax_number }}</p>
              <p v-if="route.status !== 'todo'">Belépés: {{ route.enter | dateTime }}</p>
              <p v-if="route.status === 'done' || route.status === 'failed'">Kilépés: {{ route.exit | dateTime }} </p>
              <p v-if="route.status === 'done' || route.status === 'failed'">Üzletben tartózkodás ideje: {{ getDiff(route.enter, route.exit) }} </p>
              <p v-if="route.status === 'failed' && route.failure_reason">Sikertelenség oka: {{ route.failure_reason }} </p>
              <p v-if="route.status === 'failed' && !route.failure_reason">Sikertelenség oka:
                <el-tag size="mini" type="danger" style="margin-left: 5px">Nem lett kitöltve</el-tag>
              </p>
            </div>
          </el-card>

        </el-timeline-item>
      </el-timeline>
    </template>
  </el-table-column>
</template>

<script>
  import moment from 'moment'

  export default {
    propName: 'routes',
    methods: {
      getDiff(enter, exit) {
        const minutes = parseInt(moment(exit).diff(moment(enter)) / 1000 / 60);
        const seconds = moment(exit).diff(moment(enter)) / 1000 - minutes * 60;
        return minutes ? minutes + ' perc ' + (seconds ? seconds + ' másodperc' : '') : seconds + 'másodperc';
      },
      getStatus(status) {
        let config = {
          type: '',
          icon: '',
        };
        switch (status) {
          case 'todo':
            break;
          case 'done':
            config.icon = 'el-icon-check';
            config.type = 'success';
            break;
          case 'in-progress':
            config.icon = 'el-icon-more';
            config.type = 'warning';
            break;
          case 'failed':
            config.icon = 'el-icon-close';
            config.type = 'danger';
            break;
        }
        return config;
      }
    }
  };
</script>
<style scoped>
  .route-timeline {
    padding-left: 2px;
    margin-top: 25px;
  }
</style>
